import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import {
  type ContractType,
  type PaidSpecContractType,
} from '@/common/types/contract';
import { H1 } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import { ContractRewardsList } from '../../ContractRewardsList/ContractRewardsList';
import { images } from '../config';

interface PlusContractGeneralInfoProps {
  kind: PaidSpecContractType;
}

const PlusContractGeneralInfo: FC<PlusContractGeneralInfoProps> = ({
  kind,
}) => {
  const { t } = useTranslation();

  const title: Partial<Record<ContractType, string>> = {
    GoldenPlus: 'Premium+',
    BlitzPlus: 'Blitz+',
    GrandPlus: 'Grand+',
  };

  const image = kind && kind in images ? images[kind] : undefined;

  return (
    <>
      <H1 weight="extrabold" className="mt-10 md-h:mt-2">
        {t('Unlock {{contractType}}', {
          contractType: title[kind],
        })}
      </H1>
      <div className="w-full flex flex-col items-center">
        {image && <Picture {...image} alt={kind} />}
        <ContractRewardsList
          kind={kind}
          className={cn('mb-2', {
            '-mt-5': kind === 'GrandPlus',
            '-mt-8': kind === 'GoldenPlus',
          })}
        />
      </div>
    </>
  );
};

export { PlusContractGeneralInfo };
